// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__19005","addWidgetButton":"Header_addWidgetButton__oEcdy","dashboardTabs":"Header_dashboardTabs__R6A4z","active":"Header_active__23szj"};